import { render } from "./UserStatus.vue?vue&type=template&id=6a5d3b64&scoped=true"
import script from "./UserStatus.vue?vue&type=script&lang=js"
export * from "./UserStatus.vue?vue&type=script&lang=js"

import "./UserStatus.vue?vue&type=style&index=0&id=6a5d3b64&scoped=true&lang=scss"

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5d3b64"]])

export default __exports__